<template>
  <main-container>
    <a-card>
      <a-table
        row-key="id"
        :loading="loading"
        :pagination="pagination"
        :columns="columns"
        :data-source="dataSource"
        @change="handleTableChange"
      >
        <!-- type 1 -->
        <template slot="weight" slot-scope="weight">
          <div>{{ weight }} kg</div>
        </template>
        <template slot="35" slot-scope="record">
          <div>{{ record.p_35 }} € / {{ record.p_35_r }} €</div>
        </template>
        <template slot="38" slot-scope="record">
          <div>{{ record.p_38 }} € / {{ record.p_38_r }} €</div>
        </template>
        <template slot="51" slot-scope="record">
          <div>{{ record.p_51 }} € / {{ record.p_51_r }} €</div>
        </template>
        <template slot="52" slot-scope="record">
          <div>{{ record.p_52 }} € / {{ record.p_52_r }} €</div>
        </template>
        <template slot="es" slot-scope="record">
          <div>{{ record.es_price }} € / {{ record.es_price_r }} €</div>
        </template>
        <template slot="pt" slot-scope="record">
          <div>{{ record.pt_price }} € / {{ record.pt_price_r }} €</div>
        </template>
        <template slot="07" slot-scope="record">
          <div>{{ record.p_07 }} € / {{ record.p_07_r }} €</div>
        </template>
        <template slot="action" slot-scope="record">
          <a @click="handleSettingClick(record)">设置</a>
          <!--<router-link :to="{ name: $routeName.servicePriceDetail, query: { ...record } }">设置</router-link>-->
        </template>

        <!-- type 2 -->
        <template slot="weight2" slot-scope="row, record, index">
          {{ index }}
          <!-- <div>{{record.index}}</div> -->
        </template>
        <template slot="ED" slot-scope="record">
          <div>{{ record.ED.price }}</div>
        </template>
        <template slot="FR" slot-scope="record">
          <div>{{ record.FR.price }}</div>
        </template>
        <template slot="BE" slot-scope="record">
          <div>{{ record.BE.price }}</div>
        </template>
        <template slot="NL" slot-scope="record">
          <div>{{ record.NL.price }}</div>
        </template>
        <template slot="GB" slot-scope="record">
          <div>{{ record.GB.price }}</div>
        </template>
        <template slot="LU" slot-scope="record">
          <div>{{ record.LU.price }}</div>
        </template>
        <template slot="DK" slot-scope="record">
          <div>{{ record.DK.price }}</div>
        </template>
        <template slot="CZ" slot-scope="record">
          <div>{{ record.CZ.price }}</div>
        </template>
        <template slot="CH" slot-scope="record">
          <div>{{ record.CH.price }}</div>
        </template>
      </a-table>
    </a-card>
  </main-container>
</template>

<script>
import Service from '@/api/service';
const columns = [
  { title: '重', dataIndex: 'weight', scopedSlots: { customRender: 'weight' } },
  { title: '35', scopedSlots: { customRender: '35' } },
  { title: '38', scopedSlots: { customRender: '38' } },
  { title: '51', scopedSlots: { customRender: '51' } },
  { title: '52', scopedSlots: { customRender: '52' } },
  { title: 'ES', scopedSlots: { customRender: 'es' } },
  { title: 'PT', scopedSlots: { customRender: 'pt' } },
  { title: '07', scopedSlots: { customRender: '07' } },
  { key: 'action', title: '操作', scopedSlots: { customRender: 'action' } },
];
const column2 = [
  { title: '重量', scopedSlots: { customRender: 'weight2' } },
  { title: 'DE', scopedSlots: { customRender: 'DE' } },
  { title: 'FR', scopedSlots: { customRender: 'FR' } },
  { title: 'BE', scopedSlots: { customRender: 'BE' } },
  { title: 'NL', scopedSlots: { customRender: 'NL' } },
  { title: 'GB', scopedSlots: { customRender: 'GB' } },
  { title: 'AT', scopedSlots: { customRender: 'AT' } },
  { title: 'LU', scopedSlots: { customRender: 'LU' } },
  { title: 'DK', scopedSlots: { customRender: 'DK' } },
  { title: 'CZ', scopedSlots: { customRender: 'CZ' } },
  { title: 'CH', scopedSlots: { customRender: 'CH' } },
];
export default {
  name: 'ServicePriceList',

  data() {
    return {
      columns,
      loading: false,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        'show-size-changer': true,
        'show-total': total => `共 ${total} 条`,
      },
    };
  },

  created() {
    this.loadServicePrice();
    if (this.$route.query.type != 1) {
      this.columns = column2;
    }
  },
  methods: {
    loadServicePrice() {
      this.loading = true;
      Service.getServicePrice({
        type: this.$route.query.type,
        service_id: this.$route.query.type,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.loadServicePrice();
    },

    handleSettingClick(record) {
      this.$store.commit('price/setPriceDetail', record);
      this.$router.push({ name: this.$routeName.servicePriceDetail });
    },
  },
};
</script>

<style scoped></style>
